import { Col, Form, ListGroup, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";

const ViewRestDataSourceResponse = (props) => {
    return (
        <>
            <Modal show={props.openViewDetails} onHide={props.handleCloseViewDetails} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View JSON</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="customermanagement-view-details-btns-container border-0 p-0">
                        <div className="customermanagement-view-details-first-col border-0">
                            <ListGroup variant="flush" className='head-quarters-list-items'>
                                <ListGroup.Item style={{ gridTemplateColumns: "170px 8px minmax(0, 1fr)" }}>
                                    <p>API</p> <p>: </p>
                                    <p>{"http://excomatixapi.betaphase.in/excomatixservices/api/Designation/PostAddDesignation"}</p>
                                </ListGroup.Item>
                            </ListGroup>
                            <ListGroup variant="flush" className='head-quarters-list-items'>
                                <ListGroup.Item style={{ gridTemplateColumns: "170px 8px minmax(0, 1fr)" }}>
                                    <p>Parameters</p> <p>: </p>
                                    <p>
                                        {"{"}
                                        <br />
                                        &nbsp;&nbsp;"DesignationName": "Software Developer",<br />
                                        &nbsp;&nbsp;"StatusID": 10,<br />
                                        &nbsp;&nbsp;"DepartmentID": 1,<br />
                                        &nbsp;&nbsp;"ReportingDesignationID": 1,<br />
                                        &nbsp;&nbsp;"DesignationDescription": "Designation for Software Developer",<br />
                                        &nbsp;&nbsp;"AddedByID": 1<br />
                                        {"}"}
                                    </p>
                                </ListGroup.Item>
                            </ListGroup>
                            <ListGroup variant="flush" className='head-quarters-list-items'>
                                <ListGroup.Item style={{ gridTemplateColumns: "170px 8px minmax(0, 1fr)" }}>
                                    <p>Response</p> <p>: </p>
                                    <p>
                                        {"{"}
                                        <br />
                                        &nbsp;&nbsp;"Success": 1,<br />
                                        &nbsp;&nbsp;"Msg": "Success: Designation \\"Software Developer\\" has been added successfully."<br />
                                        {"}"}
                                    </p>
                                </ListGroup.Item>
                            </ListGroup>
                        </div>
                    </div>
                </Modal.Body >
                <Modal.Footer>
                    <SBSaveUpdateBtn btnName="Ok" onClickEffect={props.handleCloseViewDetails} />
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default ViewRestDataSourceResponse;
